import React, { useState } from 'react'
import { ISOStringToDateFormatStbDate } from '../../../lib/utils';


export type EmailItemProps = {
  date: string
  subject: string
  href: string
}
function EmailItem (props:EmailItemProps) {

  const { date, subject, href } = props;
  const [ wobble, setWobble ] = useState('')
  
  // const hoverAnimation = () =>{
  //   setWobble('wobble')
  //   console.log('hover...')
  // }
  return(
      <a href={href} rel="noopener noreferrer" target="_blank">
        <div 
          className={`item ${wobble}`} 
          // onMouseOver={hoverAnimation}
          // onMouseLeave={()=>setWobble('')}
          // onAnimationEnd={()=>setWobble('')}
          >
          <span className='date'>{ISOStringToDateFormatStbDate(date)}</span>
          {subject}
        </div>
      </a>

  )
}

export default EmailItem;